import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './ui/dialog';

const ROWS = [
  { size: 'XS', bust: 32, waist: 26, hip: 35 },
  { size: 'S', bust: 34, waist: 28, hip: 37 },
  { size: 'M', bust: 36, waist: 30, hip: 39 },
  { size: 'L', bust: 38, waist: 32, hip: 41 },
  { size: 'XL', bust: 40, waist: 34, hip: 43 },
  { size: 'XXL', bust: 42, waist: 36, hip: 45 },
];

export default function SizeChart({ trigger }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-lg bg-cream" data-testid="size-chart-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-burgundy-900">Size Guide</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-burgundy-900/70 mb-4 leading-relaxed">
          All measurements are in inches. Prefer your own fit? Every HITÉRA piece is custom-made — just share your measurements and we'll tailor it exactly to you.
        </p>
        <div className="overflow-hidden border border-gold/25">
          <table className="w-full text-sm" data-testid="size-chart-table">
            <thead>
              <tr className="bg-burgundy-900 text-cream">
                <th className="py-3 px-3 text-left font-normal tracking-wide">Size</th>
                <th className="py-3 px-3 text-left font-normal tracking-wide">Bust</th>
                <th className="py-3 px-3 text-left font-normal tracking-wide">Waist</th>
                <th className="py-3 px-3 text-left font-normal tracking-wide">Hip</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r, i) => (
                <tr key={r.size} className={i % 2 ? 'bg-white' : 'bg-cream'}>
                  <td className="py-2.5 px-3 text-burgundy-900 font-medium">{r.size}</td>
                  <td className="py-2.5 px-3 text-burgundy-900/80">{r.bust}"</td>
                  <td className="py-2.5 px-3 text-burgundy-900/80">{r.waist}"</td>
                  <td className="py-2.5 px-3 text-burgundy-900/80">{r.hip}"</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-burgundy-900/50 mt-4">
          Tip: measure over your undergarments, keeping the tape snug but not tight. Reach us on WhatsApp if you need help.
        </p>
      </DialogContent>
    </Dialog>
  );
}
